
import { CONFIG } from "@/constants/config"
import { Color, Prisma } from "@prisma/client"
import { type ClassValue, clsx } from "clsx"
import { isValid } from "date-fns"
import { ReadonlyURLSearchParams } from "next/navigation"
import React from "react"
import { twMerge } from "tailwind-merge"
import { z } from "zod"
import day from "./dayjs"
import { dateString } from "./string/date-string"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}


export async function wait(duration: number) {
    return new Promise((resolve) => setTimeout(resolve, duration))
}

export const childrenWithProps = (children: React.ReactNode, props: { [k: string]: any }) => React.Children.map(children, child => {
    // Checking isValidElement is the safe way and avoids a
    // typescript error too.
    if (React.isValidElement(child)) {
        return React.cloneElement(child, props);
    }
    return child;
});


export function overlap(startA: Date, endA: Date, startB: Date, endB: Date) {
    return (
        // start of A is in B
        (startB <= startA && startA < endB) ||
        // end of A is in B
        (startB < endA && endA <= endB) ||
        // start of B is in A
        (startA <= startB && startB < endA) ||
        // end of B is in A
        (startA < endB && endB <= endA)
    );
}

// * ------------------------------------ * //

export const reorder = <T extends { id: number, order: number }>(
    items: T[],
    activeId: number,
    targetId: number
): T[] => {
    const activeIndex = items.findIndex((item) => item.id === activeId);
    const targetIndex = items.findIndex((item) => item.id === targetId);

    items.splice(targetIndex, 0, items.splice(activeIndex, 1)[0]);

    let [lower_index, higher_index] = activeIndex < targetIndex ? [activeIndex, targetIndex] : [targetIndex, activeIndex]

    for (let i = lower_index; i <= higher_index; i++) {

    }


    const offset = items[0].order > items.length ? 0 : items.length + 1; // a cause de la contrainte @@unique[administrationId, order]

    return items.map((item, index) => ({ ...item, id: item.id, order: index + offset }));
}

// * ------------------------------------ * //

export function isValidErrorCode(code: string) {
    return !isNaN(Number(code));
}

// * ------------------------------------ * //
export function areDifferentOrders<T extends { id: number; order: number }>(
    previousTable: T[],
    newTable: T[]
) {
    return previousTable.reduce<boolean>((dirtied, previous_item, index) => {
        return dirtied || newTable.some(new_item => new_item.id === previous_item.id && new_item.order !== previous_item.order)
    }, false);
}

// * ------------------------------------ * //
export function reversedArray<T>(array: T[]) {
    const newArray = [...array];
    newArray.reverse();
    return newArray;
}

export function countPages(tableCount: number, itemsPerPage: number) {
    return Math.ceil(tableCount / itemsPerPage);
}



export function getRandomHexColor() {
    const r = (Math.round(Math.random() * 255)).toString(16);
    const g = (Math.round(Math.random() * 255)).toString(16);
    const b = (Math.round(Math.random() * 255)).toString(16);
    return "#" + r + g + b;
}

export function areDatesEquals(a: Date, b: Date) {
    return a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate();
}










export async function simpleFetch<ResponseType>(route: string): Promise<ResponseType> {
    const response = await fetch(route)
    return await response.json() as ResponseType
}
